import { tryLoadLightDOMStyles } from '../Global/loadDependency'
import { getTemplateTemplateScaffoldStyles } from './UserDetails.styles'
import '../Global/global'

const t = document.createElement('template')
t.innerHTML = `
<div class="user-details-frame">
  <div class="user-details-frame-name-wrapper">
    <slot name="username"></slot>
  </div>
    <slot></slot>
</div>
`
const TemplateUserDetails = t

class UserDetails extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateTemplateScaffoldStyles().content.cloneNode(true))
    shadow.appendChild(TemplateUserDetails.content.cloneNode(true))

    tryLoadLightDOMStyles('UserDetails.css')
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('UserDetails connectedCallback')
  }
}

if (!customElements.get('ts-userdetails')) {
  customElements.define('ts-userdetails', UserDetails)
}
export { UserDetails }
